import { createGlobalStyle } from "styled-components";

export const CommunityHomeCss = createGlobalStyle`
    .community-parent-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 2% 7%;
    }
    .community-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        color: #4f5d73;
        font-weight: bold;
    }
    .community-content {
        width: 100%;
        margin-top: 1%;
    }
`;
